import { useDispatch, useSelector } from "react-redux";

import TabSelect, { TabItem } from "@/components/tabSelect";
import Section from "@/components/ui/section";
import { RootState } from "@/store";
import { setCatchmentSettingsTemp } from "@/store/slice/spatialSlice";
import { CatchmentInputBy, ECatchmentInputBy } from "@/types/spatial";

import CatchmentPlace from "../catchmentPlaceSection";
import CatchmentDataset from "./catchmentDataset";

const CATCHMENT_DATA_TYPE: TabItem[] = [
  {
    label: "Location",
    value: "location"
  },
  {
    label: "Dataset",
    value: "dataset"
  }
];

interface Props {
  onOpenDatasetTabularModal?: () => void;
}

const CatchmentDataSection = ({ onOpenDatasetTabularModal }: Props) => {
  const dispatch = useDispatch();
  const { catchmentSettingsTemp } = useSelector(
    (state: RootState) => state.spatial
  );
  return (
    <div className="flex flex-col px-4 gap-2">
      <Section label="Input Location by">
        <TabSelect
          className="h-[32px]"
          buttonClassName="text-xs h-[24px]"
          wrapperListClassName="w-full"
          tabList={CATCHMENT_DATA_TYPE}
          selected={catchmentSettingsTemp.catchmentInputBy}
          onSelect={(data) => {
            dispatch(
              setCatchmentSettingsTemp({
                catchmentInputBy: data as CatchmentInputBy
              })
            );
          }}
        />
      </Section>
      {catchmentSettingsTemp.catchmentInputBy ===
        ECatchmentInputBy.BY_LOCATION && <CatchmentPlace />}
      {catchmentSettingsTemp.catchmentInputBy ===
        ECatchmentInputBy.BY_DATASET && (
        <CatchmentDataset
          onOpenDatasetTabularModal={onOpenDatasetTabularModal}
        />
      )}
    </div>
  );
};

export default CatchmentDataSection;
